module.exports = __webpack_public_path__ + "img/SKMJ_y.56167a3d.jpg";